import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M12 2.2a.8.8 0 0 1 .8.8v3.6a.8.8 0 0 1-1.6 0V3a.8.8 0 0 1 .8-.8ZM5.07 5.07a.8.8 0 0 1 1.132 0l2.547 2.547A.8.8 0 0 1 7.617 8.75L5.07 6.203a.8.8 0 0 1 0-1.132Zm13.642.063a.8.8 0 0 1 0 1.132l-2.547 2.547a.8.8 0 0 1-1.131-1.132l2.546-2.547a.8.8 0 0 1 1.132 0ZM2.199 12a.8.8 0 0 1 .8-.8h3.6a.8.8 0 1 1 0 1.6H3a.8.8 0 0 1-.8-.8Zm14.4 0a.8.8 0 0 1 .8-.8H21a.8.8 0 1 1 0 1.6h-3.6a.8.8 0 0 1-.8-.8Zm-7.85 3.25a.8.8 0 0 1 0 1.132l-2.547 2.547a.8.8 0 0 1-1.132-1.132l2.547-2.547a.8.8 0 0 1 1.132 0Zm6.5 0a.8.8 0 0 1 1.132 0l2.547 2.547a.8.8 0 1 1-1.131 1.132l-2.547-2.547a.8.8 0 0 1 0-1.132ZM12 16.6a.8.8 0 0 1 .8.8V21a.8.8 0 0 1-1.6 0v-3.6a.8.8 0 0 1 .8-.8Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }